import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CircularProgress } from "@mui/material";
import { fDummyFunction, GridDataColumn } from "./Action";
import "./ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";
const GCLinkDocument = ({
  xOpen = false,
  fCloseDetailModal,
  GridDataLinkDocumentColumns,
  GridDataLinkDocumentRows = [],
  xTitle = "Link Document",
  xLabelVocType = "",
  xLabelVocName = "",
  xLabelVocNo = "",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  return (
    <Modal
      open={xOpen}
      onClose={fCloseDetailModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-gc-search"
      >
         <GCTitleSticky
        title={xTitle}
        onClose={fCloseDetailModal}
        />
        

        <div className="p-2">
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="mt-2 justify-content-between"
          >
            <Grid item xs={3} sm={1} md={1} className="gnr-item-search-label ">
              VocType
            </Grid>
            <Grid
              item
              xs={8}
              sm={11}
              md={11}
              className="gnr-item-search-label "
            >
              {xLabelVocType}
            </Grid>
            <Grid item xs={3} sm={1} md={1} className="gnr-item-search-label ">
              VocName
            </Grid>
            <Grid
              item
              xs={8}
              sm={11}
              md={11}
              className="gnr-item-search-label "
            >
              {xLabelVocName}
            </Grid>
            <Grid item xs={3} sm={1} md={1} className="gnr-item-search-label ">
              VocNo
            </Grid>
            <Grid
              item
              xs={8}
              sm={11}
              md={11}
              className="gnr-item-search-label "
            >
              {xLabelVocNo}
            </Grid>
            {/* <Grid item xs={3}>
              kasdasd
            </Grid> */}
          </Grid>
          {false ? (
            <div className="text-center">
              <CircularProgress />
            </div>
          ) : (
            <Grid container spacing={1} className="search-item ">
              <Grid
                item
                xs={12}
                className=" height-table-scroll"
                component="div"
              >
                <div
                  style={{
                    height: vMediaQuery ? "50vh" : "58vh",
                    width: "100%",
                  }}
                  id="table-main-grid-3"
                  className="search-grid-table mt-2"
                >
                  <Box style={{ height: "100%", width: "100%" }}>
                    <DataGrid
                      rowHeight={30}
                      headerHeight={40}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "mui-even-row"
                          : "mui-odd-row"
                      }
                      sx={{
                        border: 1,
                        borderColor: "primary.light",
                      }}
                      rows={GridDataLinkDocumentRows}
                      columns={
                        !!GridDataLinkDocumentColumns
                          ? GridDataLinkDocumentColumns
                          : GridDataColumn
                      }
                      getRowId={(row) => row.id}
                      hideFooter={GridDataLinkDocumentRows.length < 100}
                      components={{
                        Toolbar: GridToolbar,
                      }}
                    />
                  </Box>
                </div>
              </Grid>
            </Grid>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default GCLinkDocument;
